import { render, staticRenderFns } from "./ArrowDownLeft.vue?vue&type=template&id=6a994a2a&"
import script from "./ArrowDownLeft.vue?vue&type=script&lang=js&"
export * from "./ArrowDownLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports